exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.home-search input::placeholder{font-size:26px\n}\n.home-search i{transform:none!important\n}\n.home-search-results.v-menu__content{max-height:600px!important;overflow-y:hidden\n}\n.home-search-results .v-list__tile{height:60px\n}\n.home-search-input{margin-top:25vh!important\n}\n.home-search-input .v-input{font-size:40px\n}\n.home-search-input .v-input input{max-height:1.2em\n}\n.home-search-input .v-input .v-text-field__slot{margin-bottom:10px\n}\n.home-search-input .v-input label{font-size:25px;height:1em;margin-top:16px\n}\n.home-search-input .v-input .v-icon{font-size:40px;margin-top:30px\n}", ""]);

// exports
